<template>
  <div class="order_item_container bg_white">
    <div class="order_content_top">
      <div class="sn">订单号: {{ order.sn }}</div>
      <div class="status">{{ order.status | statusFilter }}</div>
    </div>
    <div class="order_content_detail" @click="gotoActivity">
      <div class="thumb">
        <img :src="order.activity_picture_url">
      </div>
      <div class="detail_content">
        <div class="title m_bottom">{{ order.title }}</div>
        <div>活动时间: {{ order.activity_start }} ~ {{ order.activity_end }}</div>
        <div>活动人数: {{ order.adult_num }}成人 {{ order.child_num }}学生</div>
      </div>
      <div class="price">¥ {{ order.total_price }}</div>
    </div>
    <div class="order_content_bottom">
      <div v-if="showDelBtn" class="btn del_btn" @click="del">删除</div>
      <div v-if="showPayBtn" class="btn pay_btn" @click="pay">去支付</div>
      <div v-if="showEvaluateBtn" class="btn evaluate_btn" @click="evaluate">去评价</div>
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { delOrder } from '@/api/order'

export default {
  name: 'order-item',
  props: ['order'],
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
    showDelBtn () {
      return this.order.status === 1 || this.order.status === 5
    },
    showPayBtn () {
      return this.order.status === 1
    },
    showEvaluateBtn () {
      return this.order.status === 3
    }
  },
  filters: {
    statusFilter (status) {
      const statusMap = {
        1: '待付款',
        2: '未出行',
        3: '待评价',
        4: '已退款',
        5: '已关闭',
        6: '交易成功'
      }
      return statusMap[status]
    }
  },
  created () {
  },
  methods: {
    async del () {
      let action = await MessageBox({
        title: '注意',
        message: '确定要删除吗?',
        showCancelButton: true
      })
      if (action === 'confirm') {
        await delOrder(this.order.id)
        Toast({ message: '删除成功', position: 'middle', duration: 2000 })
        this.$emit('del')
      }
    },
    gotoActivity () {
      this.$router.push('/act/' + this.order.activity + '/detail')
    },
    pay () {
      this.$router.push('/order/' + this.order.id + '/confirm')
    },
    evaluate () {
      this.$router.push('/order/' + this.order.id + '/evaluate')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .order_item_container {
    color: #333;
    margin-bottom: rem(10);
    .order_content_top {
      padding: 0 rem(25);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: rem(70);
      .status {
        color: #ff5000;
      }
    }
    .order_content_detail {
      padding: rem(20) rem(25);
      display: flex;
      justify-content: space-between;
      .thumb {
        width: rem(120);
        img {
          width: 100%;
        }
      }
      .detail_content {
        width: rem(350);
        color: #999;
        font-size: rem(20);
        .title {
          color: #333;
          font-size: rem(24);
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .price {
        width: rem(100);
        text-align: right;
      }
    }
    .order_content_bottom {
      height: rem(80);
      padding: 0 rem(25);
      border-bottom: 1px solid #f5f5f5;
      border-top: 1px solid #f5f5f5;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn {
        font-size: rem(23);
        width: rem(110);
        height: rem(42);
        margin-left: rem(25);
        border: 1px solid #999;
        border-radius: rem(20);
        display: flex;
        justify-content: center;
        align-items: center;
        &.pay_btn {
          color: red;
          border-color: red;
        }
        &.evaluate_btn {
          color: #ff9500;
          border-color: #ff9500;
        }
      }
    }
  }
</style>
